import $ from 'jquery';

$(document).ready(function () {
  var urlTemplate,
    groupIdInput,
    companyFilterTemplate,
    groupFilterTemplate,
    updateButton,
    updateIframeSrc;
  var container = $('iframe#dashboard-container');
  var dashboardId = $('#dashboard_id');
  var eventListenerAdded = false;
  var adjustIframeHeight = function () {
    // Listen for messages in the parent app window
    if (window.addEventListener && !eventListenerAdded) {
      window.addEventListener(
        'message',
        function (e) {
          var message = JSON.parse(e.data);
          if (message.gdc) {
            message = message.gdc;
            if (message.name == 'ui.frameinfo') {
              container.css('height', message.data.height - 20);
            }
          }
        },
        false,
      );
      eventListenerAdded = true;
    }
  };

  if (container.length) {
    urlTemplate = $('#dashboard-url-template').val();
    groupIdInput = $('#group_ids');
    companyFilterTemplate = $('#dashboard-company-filter').val();
    groupFilterTemplate = $('#dashboard-group-filter').val();
    updateButton = $('.js-update-button');

    updateIframeSrc = function () {
      var requestUrl = urlTemplate.replace('[object_id]', dashboardId.val());

      if (!groupIdInput.val()) {
        requestUrl = requestUrl.replace(
          '[iframe_filter]',
          companyFilterTemplate,
        );
      } else {
        requestUrl = requestUrl.replace(
          '[iframe_filter]',
          groupFilterTemplate.replace('[group_ids]', groupIdInput.val()),
        );
      }

      container.attr('src', requestUrl);
    };
    window.setTimeout(updateIframeSrc, 0);
    updateButton.on('click', updateIframeSrc);
    adjustIframeHeight();
    window.onresize = adjustIframeHeight;
  }
});
